import { useEffect, useState } from 'react';
import { getWindowLocation } from './window';
import { getAll, stringify } from './queryParams';

const Overlay: React.FC<React.PropsWithChildren> = ({ children }) => (
  <span
    style={{
      position: 'absolute',
      top: '3px',
      left: '3px',
      padding: '8px',
      background: 'orange',
      color: 'white',
      zIndex: '99999999',
      borderRadius: '3px',
      fontFamily: 'sans-serif',
    }}
  >
    {children}
  </span>
);

export const getParams = (origin: string, pathname: string) => {
  const { v, ...searchParamsRest } = getAll();

  const resetUrl = `${origin}${pathname}?${stringify(searchParamsRest)}`;

  return {
    version: v,
    resetUrl,
  };
};

export const VersionResetOverlay = () => {
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    setIsHidden(false);
  }, []);

  const { origin, pathname } = getWindowLocation();
  const { version, resetUrl } = getParams(origin, pathname);

  if (!version || isHidden) {
    return null;
  }

  return (
    <Overlay>
      {version} <a href={resetUrl}>reset</a>{' '}
      <a href="#" onClick={() => setIsHidden(true)}>
        hide
      </a>
    </Overlay>
  );
};
